import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";
import CheckBox from "../../form/CheckBox";
import {EditorField as Editor} from "../../form/editor/editor";
import TypeTextEditor from "../../form/TypeTextEditor";
import PriorityField from "../../form/PriorityField";
import UrlField from "../../form/UrlField";
import Figures from "../../form/Figures";
import SeoField from "../../form/SeoField";

class articleForm extends React.Component {
    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-2 col-sm-push-10">
                        <TextInput
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                        />
                    </div>
                    <div className="col-sm-10 col-sm-pull-2">
                        <TextInput
                            {...this.props.getFieldProps("headline")}
                            name="headline"
                            value={this.props.values.headline}
                            label="Cím"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <TextInput
                            {...this.props.getFieldProps("subhead")}
                            name="subhead"
                            value={this.props.values.subhead}
                            label="Alcím"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-4">
                        <Select
                            {...this.props.getFieldProps("author")}
                            objectValue={false}
                            name="author"
                            component={this.props.componentConfig.fielddefs.author.object}
                            labelKey="name"
                            storeType="remote"
                            value={this.props.values.author}
                            label="Szerző"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-4">
                        <Select
                            {...this.props.getFieldProps("publisher")}
                            objectValue={false}
                            name="publisher"
                            component="user"
                            labelKey="name"
                            storeType="remote"
                            value={this.props.values.publisher}
                            label="Közzétevő"
                            disabled={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <Select
                            {...this.props.getFieldProps("type")}
                            name="type"
                            optionname="articletype"
                            storeType="local"
                            objectValue={false}
                            saveChanges={this.props.setFieldValue}
                            value={this.props.values.type}
                            label="Típus"
                        />
                    </div>
                    <div className="col-sm-4">
                        <DateTimeInput
                            {...this.props.getFieldProps("startdate")}
                            name="startdate"
                            value={this.props.values.startdate}
                            label="Kezdés"
                            showTime={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-4">
                        <DateTimeInput
                            {...this.props.getFieldProps("expiry")}
                            name="expiry"
                            value={this.props.values.expiry}
                            label="Lejárat"
                            showTime={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-8">
                        <Select
                            {...this.props.getFieldProps("tags")}
                            name="tags"
                            component="tag"
                            isMulti={true}
                            labelKey="tagname"
                            storeType="remote"
                            objectValue={false}
                            saveChanges={this.props.setFieldValue}
                            value={ this.props.values.tags }
                            label="Kulcsszavak"
                        />
                    </div>
                    <div className="col-md-4">
                        <Select
                            {...this.props.getFieldProps("blogsection")}
                            name="blogsection"
                            component="blogsection"
                            storeType="local"
                            labelKey="tagname"
                            saveChanges={this.props.setFieldValue}
                            value={this.props.values.blogsection}
                            label="Rovat"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-6">
                        <Select
                            {...this.props.getFieldProps("relatedproducts")}
                            name="relatedproducts"
                            component="product"
                            componentview="list"
                            isMulti={true}
                            objectValue={false}
                            labelKey="displayname"
                            valueKey="base_product_id"
                            storeType="remote"
                            saveChanges={this.props.setFieldValue}
                            value={this.props.values.relatedproducts}
                            label="Kapcsolódó termékek"
                        />
                    </div>
                    <div className="col-sm-6">
                        <Select
                            {...this.props.getFieldProps("relatedauthors")}
                            name="relatedauthors"
                            component="author"
                            isMulti={true}
                            objectValue={false}
                            labelKey="name"
                            storeType="remote"
                            saveChanges={this.props.setFieldValue}
                            value={this.props.values.relatedauthors}
                            label="Kapcsolódó szerzők"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-3">
                        <div className="row form-row">
                            <div className="col-sm-6">
                                <label className="control-label">&nbsp;</label>
                                <CheckBox
                                    {...this.props.getFieldProps("published")}
                                    name="published"
                                    value={this.props.values.published}
                                    label="Közzétéve"
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                            <div className="col-sm-6">
                                <label className="control-label">&nbsp;</label>
                                <CheckBox
                                    {...this.props.getFieldProps("listed")}
                                    name="listed"
                                    value={this.props.values.listed}
                                    label="Főoldal"
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-9">
                        {this.props.componentConfig.fielddefs.priority && <PriorityField {...this.props}/>}
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <TypeTextEditor
                            name="listdeck_editable"
                            label="Lista bevezető"
                            data={this.props.values}
                            componentConfig={this.props.componentConfig}
                            getFieldProps={this.props.getFieldProps}
                            setFieldValue={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <TypeTextEditor
                            name="deck"
                            label="Bevezető"
                            data={this.props.values}
                            componentConfig={this.props.componentConfig}
                            getFieldProps={this.props.getFieldProps}
                            setFieldValue={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Editor
                            {...this.props.getFieldProps("copy")}
                            name="copy"
                            component={this.props.componentConfig.componentname}
                            componentId={this.props.values[this.props.componentConfig.idfield]}
                            value={this.props.values.copy}
                            images={this.props.values.images}
                            label="Szöveg"
                            height="400px"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <Figures
                    name="images"
                    label="Képek"
                    componentConfig={this.props.componentConfig}
                    data={this.props.values}
                />
                {this.props.componentConfig.fielddefs.url && <UrlField {...this.props}/>}
                <SeoField {...this.props}/>
            </form>
        );
    }
}

export default createForm(articleForm);
